module.exports = __webpack_public_path__ + "static/media/glob.b08715fc.png";